var mentions_default = {
  "mentionPalette": "_0ojy-",
  "mention": "K0orT",
  "mentionViewer": "YL9CS",
  "mentionSuggestionsEntry": "Td01r",
  "mentionSuggestionsEntryFocused": "n2HEM",
  "mentionSuggestionsEntryText": "lik5f",
  "mentionSuggestionsEntryAvatar": "GsX-U",
  "mentionSuggestions": "fyP6K",
  "cursorDefault": "-AXTr",
  "cursorPointer": "dKWU7"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
